const getUnusedFlags = (tempTerm, tempAllFlags) => {
  const usedFlagIds = new Set();
  [
    ...tempTerm?.term1?.flags,
    ...tempTerm?.term2?.flags,
    ...tempTerm?.term3?.flags,
    ...tempTerm?.term4?.flags,
  ].forEach((flag) => usedFlagIds.add(flag.id));
  return tempAllFlags.filter((fl) => !usedFlagIds.has(fl.id));
};

export default getUnusedFlags;
